export enum SdohReferralStatus {
  Pending = 'Pending',
  Withdrawn = 'Withdrawn',
  Completed = 'Completed',
  Canceled = 'Canceled'
}

export const SdohReferralStatusLabelMap: { [key: string]: string } = {
  [SdohReferralStatus.Pending]: 'Pending',
  [SdohReferralStatus.Withdrawn]: 'Withdrawn',
  [SdohReferralStatus.Completed]: 'Completed',
  [SdohReferralStatus.Canceled]: 'Canceled'
};
